import React, { Component, Fragment } from "react";
import client from "./../../utils/apolloClient";
import { getUser } from "./../../data-services/queries";
import gql from "graphql-tag";
import getData, { pdfUpload, imageUpload } from "./../../data-services/api";
import ImageGallery from "../../components/ImageGallery";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import Loader from "./../../components/CustomLoader";
import Swal from "sweetalert2";
import noResultFoundImage from "../MyFCP/images/noResultFoundImage.png";
import pdfLogo from "../../components/Images/pdfLogo.png";
import ImageGalleryTitle from "../../components/ImageGalleryTitle";
import { documentUpload } from "./../../data-services/api/index";
import moment from "moment";

const queryString = require("query-string");

export default class ETTCUpload extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 3.5,
            FCPRating: 0,
            Uploaded_Content__c: [],
            loading: true,
            isDisabled: !!queryString.parse(window.location.search).id,
            AMMDApprovalPhoto: [],
            downloadEttcUrl: "",
            viewEttcUrl: "",
            ettcBase64URL: "",
            profile: {},
        };
    }

    async componentDidMount() {
        await client
            .query({
                query: gql(getUser)
            })
            .then(({ data }) => {
                if (data.user.role === "FCP") {
                    this.setState({
                        userData: data.user
                    });
                }
            });

        let ETTCUploadData;
        ETTCUploadData = await getData(
            `SELECT ettc_document__c, ettc_download__c
                FROM salesforce.account
                WHERE sfid = '${this.state.userData.sfid}' `
        )
        this.setState({
            downloadEttcUrl: ETTCUploadData.result[0].ettc_download__c,
            viewEttcUrl: ETTCUploadData.result[0].ettc_document__c,
            loading: false,
        });

    }

    handleAMMDPhotoUpload = name => async ({ id, document, type }) => {
        if (this.state.AMMDApprovalPhoto.length >= 1) {
            alert("Only One image can be uploaded");
        }
        else {
            var data;
            if (type.includes("image")) {
                data = await imageUpload({
                    id: id,
                    img: document,
                    type: type
                });
            }
            else {
                data = await pdfUpload({
                    id: id,
                    pdf: document,
                    type: type
                });
            }

            var openURL;
            if (document) {
                var dataUrl = document.split('base64,')
                const blob = new Blob([Uint8Array.from(atob(dataUrl[1]), c => c.charCodeAt(0))], { type: 'application/pdf' });
                openURL = URL.createObjectURL(blob);
            }
            //console.log("Data", openURL, data)
            if (data && document) {
                const URL = new Promise((resolve, reject) => {
                    const uploadImageQuery = `UPDATE salesforce.account SET 
                    ettc_document__c='${openURL}',ettc_download__c='${data.url}'  WHERE sfid = '${this.state.userData.sfid}' `;
                    const result = getData(uploadImageQuery)
                    if (result) {
                        resolve(result)
                    } else (
                        reject(result)
                    )
                })
                URL.then((result) => {
                    if (result.status === 200) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Your image uploaded successfully',
                            showConfirmButton: true,
                            confirmButtonColor: "#1a5c9a",
                        })
                        this.setState({
                            downloadEttcUrl: data.url,
                            viewEttcUrl: openURL,
                        });
                    }
                })
            }
        }
    };

    openPDF = () => {
        window.open(this.state.viewEttcUrl, '_blank');
    };

    gotoBack = () => {
        this.props.history.push({
            pathname: "/newHomeFCP",
        });
    };

    upload = name => async ({ id, document, type, lastModifiedDate }) => {
        const data = await documentUpload({
            id: id,
            img: document,
            type: type,
            lastModifiedDate: lastModifiedDate
        });
      // console.log("Image Data", data, lastModifiedDate, name);

        if (!type.includes("image")) {
            alert("Only Images can be uploaded");
        }
        else {
            const new_date = moment()
            const formattedLastModifieDate = moment(new_date).format(
                "YYYY-MM-DD HH:mm:ss"
            );

            // var herokuIDQuery = `select heroku_id__c  from salesforce.account a where sfid = '${this.state.SFID}' `;
            // const herokuIdData = await getData(herokuIDQuery);
            // const herokuID = herokuIdData.result[0].heroku_id__c;
            //console.log("herokuIDQuery", herokuIdData)

            // if (herokuIdData.status == 200) {
            //     const herokuID = herokuIdData.result[0].heroku_id__c;
            //   // console.log("herokuIDQuery", herokuID)
            var insertImageQuery = `Insert Into Salesforce.Uploaded_Content__c (Name,Image_URL__c, Account__c)
                    values('Day-${formattedLastModifieDate}','${data.url}', '${this.state.userData.sfid}') 
                    returning id `;
            const insertedId = await getData(insertImageQuery);
            if (insertedId.result && insertedId.result != false) {
                //console.log("insertedId", insertedId.result);
                Swal.fire({
                    icon: 'success',
                    title: 'Your Image is Uploaded successfully',
                    showConfirmButton: true,
                    confirmButtonColor: "#1a5c9a",
                })
                this.setState({
                    [name]: [
                        ...this.state[name],
                        { id: insertedId.result[0].id, url: data.url, type }
                    ]
                });
            } else {
                alert("Image Upload Failed-" + insertImageQuery + "-" + insertedId);
            }
            // }

        }
    };

    delete = name => async id => {
        const deleteImageQuery = `delete from Salesforce.Workshop_Photo__c  where Workshop_Heroku_Id__c='${this.state.id}' and day__c='${this.state.day}' and type__c ='${name}' and id='${id}' returning id`;

        await getData(deleteImageQuery);
        const newState = this.state[name].filter(s => {
            return s.id !== id;
        });
        this.setState({
            [name]: newState
        });
    };

    render() {

        const { isDisabled, viewEttcUrl, downloadEttcUrl, loading } = this.state;
        const { classes, history, } = this.props;

      // console.log()
        return (
            <>
                <AppBar position="static">
                    <Toolbar>
                        <Grid item xs={2} sm={2} md={2}>
                            <IconButton
                                color="inherit"
                                aria-label="Menu"
                                onClick={() => {
                                    this.gotoBack();
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={8} sm={8} md={8}>
                            <Typography
                                variant="title"
                                color="inherit"
                                className='text-center'
                            >
                                Upload your Submissions
                            </Typography>
                        </Grid>
                    </Toolbar>
                </AppBar>
                {loading ? (
                    <Grid container alignItems="center" justify="center">
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <>
                        <Paper elevation={1} style={{ padding: 7 }} square={true}>
                            <Grid container alignItems="center" justify="center">
                                <Grid item xs={4} md={4} style={{ paddingLeft: 15 }}>
                                    <Typography align="left" variant="body2">
                                        Upload submission
                                    </Typography>
                                </Grid>
                                <Grid item xs={8} md={8} style={{ paddingRight: 15 }}>
                                    <ImageGallery
                                        // disableAdd={!FCP}
                                        upload={this.upload("Uploaded_Content__c")}
                                        photos={this.state.Uploaded_Content__c}
                                    // delete={this.delete("Uploaded_Content__c")}
                                    />
                                </Grid>
                            </Grid>
                            <hr />
                            <Typography
                                variant="subtitle2"
                                align="center"
                                style={{ padding: 10 }}
                                onClick={() => {
                                    history.push({
                                        pathname: "/viewUploads",
                                        search: `?id=${this.state.userData.sfid}`,
                                        SFID: this.state.userData.sfid,
                                    });
                                }}
                            >
                                View Uploads
                            </Typography>

                            <hr />
                            <Grid container alignItems="center" justify="center">
                                <Grid item xs={4} md={4} style={{ paddingLeft: 15 }}>
                                    <Typography align="left" variant="body2">
                                        Upload ETTC Document
                                    </Typography>
                                </Grid>
                                <Grid item xs={8} md={8} style={{ paddingRight: 15 }}>
                                    <ImageGallery
                                        disableAdd={isDisabled}
                                        upload={this.handleAMMDPhotoUpload("AMMDApprovalPhoto")}
                                        photos={this.state.AMMDApprovalPhoto}
                                        // delete={this.handleDeletePhoto("AMMDApprovalPhoto")}
                                        single={true}
                                    />
                                </Grid>
                            </Grid>
                            <hr />
                            {downloadEttcUrl ?
                                <>
                                    <Typography align="center" variant="body2">
                                        ETTC Uploaded Document
                                    </Typography>
                                    {/* <div className='d-none d-md-block'>
                                        <Grid container alignItems="center" justify="center">
                                            <iframe
                                                title="PDF Viewer"
                                                src={viewEttcUrl}
                                                width="100%"
                                                height="500px"
                                                allowfullscreen
                                            ></iframe>
                                        </Grid>
                                    </div> */}
                                    <Grid container alignItems="center" justify="center">
                                        <img src={pdfLogo} style={{ marginTop: 10, width: '100px' }} />
                                    </Grid>
                                    <hr />
                                    <Grid container alignItems="center" justify="center">
                                        {/* <Grid item xs={6} md={6} style={{ paddingLeft: 15 }}>
                                            <Typography align="center" variant="body2">
                                                <a href="#" onClick={this.openPDF} target="_blank" rel="noopener noreferrer"> View PDF </a>
                                            </Typography>
                                        </Grid> */}
                                        <Grid item xs={6} md={6} style={{ paddingRight: 15 }}>
                                            <Typography align="center" variant="body2">
                                                <a href={downloadEttcUrl} download="filename.pdf">
                                                    Download PDF
                                                </a>
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </>
                                : <>
                                    <Grid container spacing={8} justify="center" alignItems="center">
                                        <img style={{ marginTop: '50px', width: 220, height: 190 }} src={noResultFoundImage} />
                                    </Grid>
                                </>
                            }
                        </Paper >
                    </>
                )}
            </>
        )
    }
}